unit Essentials.Web.Lookup.Editor;

interface

uses
  System.SysUtils,
  System.Classes,
  System.Generics.Collections,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Connection,
  XData.Web.Client,
  XData.Web.Dataset,
  WEBLib.DB,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  Essentials.Shared,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls;

type
  TEssentialsLookUpEditor = class(TCoreWebForm)
    LookupValuesSource: TDataSource;
    EntitySelector: TLookupComboBox;
    FieldSelector: TLookupComboBox;
    LoadButton: TButton;
    EssentialsLookupEditorTable: TDBTableControl;
    LookupValueEdit: TDBEdit;
    LookupDescriptionEdit: TDBEdit;
    LookupSortOrderEdit: TDBEdit;
    LookupSaveButton: TButton;
    LookupCancelButton: TButton;
    LookupAddButton: TButton;
    LookupIdLabel: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject);
    procedure LoadButtonClick(Sender: TObject);
    procedure LookupAddButtonClick(Sender: TObject);
    procedure LookupCancelButtonClick(Sender: TObject);
    procedure LookupSaveButtonClick(Sender: TObject);
    procedure LookupValuesSourceStateChange(Sender: TObject);
    procedure EssentialsLookupEditorTableClickCell(Sender: TObject; ACol,
      ARow: Integer);

  private
    [Async]
    procedure LoadEntityList; async;
    [Async]
    procedure LoadLookups; async;
    [Async]
    procedure SaveLookup; async;

  public
    { Public declarations }
    destructor Destroy; override;

  protected procedure LoadDFMValues; override; end;

var
  EssentialsLookUpEditor: TEssentialsLookUpEditor;

implementation

{$R *.dfm}

uses
  SMX.Web.Utils,
  SMX.XDataSvc.Utils,
  Essentials.Web.Shared,
  { TODO : only needed in design mode in EssentialsDemoWeb App - DO NOT leave this here when running }
//  ConnectionModule,
  Essentials.Web.Manager;

procedure TEssentialsLookUpEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  LookupValuesSource.DataSet := EssentialsManager.LookUpManager.LookupValuesDataset;
  LookupSaveButton.Enabled := False;
  LookupCancelButton.Enabled := False;
  LoadEntityList;
end;

destructor TEssentialsLookUpEditor.Destroy;
begin
  inherited;
end;

procedure TEssentialsLookUpEditor.EntitySelectorChange(Sender: TObject);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

  lFields := EssentialsManager.LookUpManager.RegisteredFields[selectedValue];

  if Assigned(lFields) then
  begin
    for fld in lFields do
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
  end;
end;

procedure TEssentialsLookUpEditor.EssentialsLookupEditorTableClickCell(
  Sender: TObject; ACol, ARow: Integer);
var
  lookupValueId: string;
begin
  lookupValueId := EssentialsLookupEditorTable.Cells[0, aRow];
  EssentialsManager.LookUpManager.LookUpValuesDataset.Locate('LookUpValue', lookUpValueId, []);
end;

procedure TEssentialsLookUpEditor.LoadButtonClick(Sender: TObject);
begin
  LoadLookups;
end;

procedure TEssentialsLookUpEditor.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
begin
  for lDef in EssentialsManager.LookUpManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
       lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);

    EntitySelector.LookupValues.AddPair(lName, lCustom);
  end;
end;

procedure TEssentialsLookUpEditor.LoadLookups;
var
  selectedEntity, selectedField: string;
begin
  selectedEntity := EntitySelector.Value;
  selectedField := FieldSelector.Value;

  Await(EssentialsManager.LookUpManager.LocateLookup(selectedEntity, selectedField));
  LookupIdLabel.Caption := EssentialsManager.LookUpManager.LookUpDataset.FieldByName('Id').AsString;

end;

procedure TEssentialsLookUpEditor.LookupAddButtonClick(Sender: TObject);
begin
  LookupValuesSource.DataSet.Insert;
end;

procedure TEssentialsLookUpEditor.LookupCancelButtonClick(Sender: TObject);
begin
  LookupValuesSource.DataSet.Cancel;
end;

procedure TEssentialsLookUpEditor.LookupSaveButtonClick(Sender: TObject);
begin
  if LookupValuesSource.DataSet.State in dsEditModes then
  begin
    LookupValuesSource.DataSet.Post;
    SaveLookup;
  end;
end;

procedure TEssentialsLookUpEditor.LookupValuesSourceStateChange(Sender:
  TObject);
begin
  LookupSaveButton.Enabled := LookupValuesSource.State in dsEditModes;
  LookupCancelButton.Enabled := LookupSaveButton.Enabled;
  LookupAddButton.Enabled := not LookupSaveButton.Enabled;
end;

procedure TEssentialsLookUpEditor.SaveLookup;
begin
  Await(EssentialsManager.LookUpManager.SaveValueChanges);
end;

procedure TEssentialsLookUpEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  LookupIdLabel := TLabel.Create('essentials.lookup.id.label');
  EntitySelector := TLookupComboBox.Create('essentials.lookup.entity.selector');
  FieldSelector := TLookupComboBox.Create('essentials.lookup.field.selector');
  LoadButton := TButton.Create('essentials.lookup.editor.load.button');
  EssentialsLookupEditorTable := TDBTableControl.Create('essentials.lookup.editor.table');
  LookupValueEdit := TDBEdit.Create('essentials.lookup.value.edit');
  LookupDescriptionEdit := TDBEdit.Create('essentials.lookup.description.edit');
  LookupSortOrderEdit := TDBEdit.Create('essentials.lookup.sortorder.edit');
  LookupSaveButton := TButton.Create('essentials.lookup.save.button');
  LookupCancelButton := TButton.Create('essentials.lookup.cancel.button');
  LookupAddButton := TButton.Create('essentials.lookup.add.button');
  LookupValuesSource := TDataSource.Create(Self);

  LookupIdLabel.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  LoadButton.BeforeLoadDFMValues;
  EssentialsLookupEditorTable.BeforeLoadDFMValues;
  LookupValueEdit.BeforeLoadDFMValues;
  LookupDescriptionEdit.BeforeLoadDFMValues;
  LookupSortOrderEdit.BeforeLoadDFMValues;
  LookupSaveButton.BeforeLoadDFMValues;
  LookupCancelButton.BeforeLoadDFMValues;
  LookupAddButton.BeforeLoadDFMValues;
  LookupValuesSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    LookupIdLabel.SetParentComponent(Self);
    LookupIdLabel.Name := 'LookupIdLabel';
    LookupIdLabel.Left := 152;
    LookupIdLabel.Top := 32;
    LookupIdLabel.Width := 78;
    LookupIdLabel.Height := 15;
    LookupIdLabel.Caption := 'LookupIdLabel';
    LookupIdLabel.ElementFont := efCSS;
    LookupIdLabel.HeightStyle := ssAuto;
    LookupIdLabel.HeightPercent := 100.000000000000000000;
    LookupIdLabel.WidthPercent := 100.000000000000000000;
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 152;
    EntitySelector.Top := 64;
    EntitySelector.Width := 145;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'custom-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.ItemIndex := -1;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 328;
    FieldSelector.Top := 64;
    FieldSelector.Width := 145;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'custom-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    FieldSelector.ItemIndex := -1;
    LoadButton.SetParentComponent(Self);
    LoadButton.Name := 'LoadButton';
    LoadButton.Left := 496;
    LoadButton.Top := 64;
    LoadButton.Width := 96;
    LoadButton.Height := 25;
    LoadButton.Caption := 'Load';
    LoadButton.ChildOrder := 2;
    LoadButton.ElementClassName := 'btn btn-light';
    LoadButton.ElementFont := efCSS;
    LoadButton.ElementPosition := epIgnore;
    LoadButton.HeightStyle := ssAuto;
    LoadButton.HeightPercent := 100.000000000000000000;
    LoadButton.WidthStyle := ssAuto;
    LoadButton.WidthPercent := 100.000000000000000000;
    SetEvent(LoadButton, Self, 'OnClick', 'LoadButtonClick');
    EssentialsLookupEditorTable.SetParentComponent(Self);
    EssentialsLookupEditorTable.Name := 'EssentialsLookupEditorTable';
    EssentialsLookupEditorTable.Left := 111;
    EssentialsLookupEditorTable.Top := 112;
    EssentialsLookupEditorTable.Width := 481;
    EssentialsLookupEditorTable.Height := 200;
    EssentialsLookupEditorTable.HeightStyle := ssAuto;
    EssentialsLookupEditorTable.WidthStyle := ssAuto;
    EssentialsLookupEditorTable.BorderColor := clSilver;
    EssentialsLookupEditorTable.ChildOrder := 3;
    EssentialsLookupEditorTable.ElementFont := efCSS;
    EssentialsLookupEditorTable.ElementHeaderClassName := 'thead-light';
    EssentialsLookupEditorTable.ElementPosition := epIgnore;
    EssentialsLookupEditorTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsLookupEditorTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsLookupEditorTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsLookupEditorTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsLookupEditorTable.Footer.InputElementClassName := 'form-control';
    EssentialsLookupEditorTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsLookupEditorTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsLookupEditorTable.Footer.ListElementClassName := 'pagination';
    EssentialsLookupEditorTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsLookupEditorTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsLookupEditorTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsLookupEditorTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsLookupEditorTable.Header.DropDownElementClassName := 'form-control';
    EssentialsLookupEditorTable.Header.InputElementClassName := 'form-control';
    EssentialsLookupEditorTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsLookupEditorTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsLookupEditorTable.Header.ListElementClassName := 'pagination';
    EssentialsLookupEditorTable.Header.ListItemElementClassName := 'page-item';
    EssentialsLookupEditorTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsLookupEditorTable, Self, 'OnClickCell', 'EssentialsLookupEditorTableClickCell');
    EssentialsLookupEditorTable.Columns.Clear;
    with EssentialsLookupEditorTable.Columns.Add do
    begin
      DataField := 'LookUpValue';
      Title := 'Look Up Value';
      Width := 150;
    end;
    with EssentialsLookupEditorTable.Columns.Add do
    begin
      DataField := 'SortOrder';
      Title := 'Sort Order';
      Width := 20;
    end;
    with EssentialsLookupEditorTable.Columns.Add do
    begin
      DataField := 'Description';
      Title := 'Description';
      Width := 200;
    end;
    EssentialsLookupEditorTable.DataSource := LookupValuesSource;
    LookupValueEdit.SetParentComponent(Self);
    LookupValueEdit.Name := 'LookupValueEdit';
    LookupValueEdit.Left := 71;
    LookupValueEdit.Top := 368;
    LookupValueEdit.Width := 171;
    LookupValueEdit.Height := 22;
    LookupValueEdit.ChildOrder := 4;
    LookupValueEdit.ElementClassName := 'form-control';
    LookupValueEdit.ElementFont := efCSS;
    LookupValueEdit.ElementPosition := epIgnore;
    LookupValueEdit.HeightStyle := ssAuto;
    LookupValueEdit.HeightPercent := 100.000000000000000000;
    LookupValueEdit.Text := 'LookupValueEdit';
    LookupValueEdit.WidthStyle := ssAuto;
    LookupValueEdit.WidthPercent := 100.000000000000000000;
    LookupValueEdit.DataField := 'LookUpValue';
    LookupValueEdit.DataSource := LookupValuesSource;
    LookupDescriptionEdit.SetParentComponent(Self);
    LookupDescriptionEdit.Name := 'LookupDescriptionEdit';
    LookupDescriptionEdit.Left := 375;
    LookupDescriptionEdit.Top := 368;
    LookupDescriptionEdit.Width := 242;
    LookupDescriptionEdit.Height := 22;
    LookupDescriptionEdit.ChildOrder := 4;
    LookupDescriptionEdit.ElementClassName := 'form-control';
    LookupDescriptionEdit.ElementFont := efCSS;
    LookupDescriptionEdit.ElementPosition := epIgnore;
    LookupDescriptionEdit.HeightStyle := ssAuto;
    LookupDescriptionEdit.HeightPercent := 100.000000000000000000;
    LookupDescriptionEdit.Text := 'LookupDescriptionEdit';
    LookupDescriptionEdit.WidthStyle := ssAuto;
    LookupDescriptionEdit.WidthPercent := 100.000000000000000000;
    LookupDescriptionEdit.DataField := 'Description';
    LookupDescriptionEdit.DataSource := LookupValuesSource;
    LookupSortOrderEdit.SetParentComponent(Self);
    LookupSortOrderEdit.Name := 'LookupSortOrderEdit';
    LookupSortOrderEdit.Left := 248;
    LookupSortOrderEdit.Top := 368;
    LookupSortOrderEdit.Width := 121;
    LookupSortOrderEdit.Height := 22;
    LookupSortOrderEdit.ChildOrder := 6;
    LookupSortOrderEdit.EditType := weNumeric;
    LookupSortOrderEdit.ElementClassName := 'form-control';
    LookupSortOrderEdit.ElementFont := efCSS;
    LookupSortOrderEdit.ElementPosition := epIgnore;
    LookupSortOrderEdit.HeightStyle := ssAuto;
    LookupSortOrderEdit.HeightPercent := 100.000000000000000000;
    LookupSortOrderEdit.Text := 'LookupSortOrderEdit';
    LookupSortOrderEdit.WidthStyle := ssAuto;
    LookupSortOrderEdit.WidthPercent := 100.000000000000000000;
    LookupSortOrderEdit.DataField := 'SortOrder';
    LookupSortOrderEdit.DataSource := LookupValuesSource;
    LookupSaveButton.SetParentComponent(Self);
    LookupSaveButton.Name := 'LookupSaveButton';
    LookupSaveButton.Left := 328;
    LookupSaveButton.Top := 416;
    LookupSaveButton.Width := 96;
    LookupSaveButton.Height := 25;
    LookupSaveButton.Caption := 'Save';
    LookupSaveButton.ChildOrder := 7;
    LookupSaveButton.ElementClassName := 'btn btn-light';
    LookupSaveButton.ElementFont := efCSS;
    LookupSaveButton.ElementPosition := epIgnore;
    LookupSaveButton.HeightStyle := ssAuto;
    LookupSaveButton.HeightPercent := 100.000000000000000000;
    LookupSaveButton.WidthStyle := ssAuto;
    LookupSaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(LookupSaveButton, Self, 'OnClick', 'LookupSaveButtonClick');
    LookupCancelButton.SetParentComponent(Self);
    LookupCancelButton.Name := 'LookupCancelButton';
    LookupCancelButton.Left := 226;
    LookupCancelButton.Top := 416;
    LookupCancelButton.Width := 96;
    LookupCancelButton.Height := 25;
    LookupCancelButton.Caption := 'Cancel';
    LookupCancelButton.ChildOrder := 7;
    LookupCancelButton.ElementClassName := 'btn btn-light';
    LookupCancelButton.ElementFont := efCSS;
    LookupCancelButton.ElementPosition := epIgnore;
    LookupCancelButton.HeightStyle := ssAuto;
    LookupCancelButton.HeightPercent := 100.000000000000000000;
    LookupCancelButton.WidthStyle := ssAuto;
    LookupCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(LookupCancelButton, Self, 'OnClick', 'LookupCancelButtonClick');
    LookupAddButton.SetParentComponent(Self);
    LookupAddButton.Name := 'LookupAddButton';
    LookupAddButton.Left := 111;
    LookupAddButton.Top := 416;
    LookupAddButton.Width := 96;
    LookupAddButton.Height := 25;
    LookupAddButton.Caption := 'Add';
    LookupAddButton.ChildOrder := 7;
    LookupAddButton.ElementClassName := 'btn btn-light';
    LookupAddButton.ElementFont := efCSS;
    LookupAddButton.ElementPosition := epIgnore;
    LookupAddButton.HeightStyle := ssAuto;
    LookupAddButton.HeightPercent := 100.000000000000000000;
    LookupAddButton.WidthStyle := ssAuto;
    LookupAddButton.WidthPercent := 100.000000000000000000;
    SetEvent(LookupAddButton, Self, 'OnClick', 'LookupAddButtonClick');
    LookupValuesSource.SetParentComponent(Self);
    LookupValuesSource.Name := 'LookupValuesSource';
    SetEvent(LookupValuesSource, Self, 'OnStateChange', 'LookupValuesSourceStateChange');
    LookupValuesSource.Left := 64;
    LookupValuesSource.Top := 56;
  finally
    LookupIdLabel.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
    LoadButton.AfterLoadDFMValues;
    EssentialsLookupEditorTable.AfterLoadDFMValues;
    LookupValueEdit.AfterLoadDFMValues;
    LookupDescriptionEdit.AfterLoadDFMValues;
    LookupSortOrderEdit.AfterLoadDFMValues;
    LookupSaveButton.AfterLoadDFMValues;
    LookupCancelButton.AfterLoadDFMValues;
    LookupAddButton.AfterLoadDFMValues;
    LookupValuesSource.AfterLoadDFMValues;
  end;
end;

end.

